export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_URL,
  endpoints: {
    videos: "/videos",
    videoUrl: "/video",
    thumbnails: "/thumbnails",
    share: "/share",
    sharedClip: "/shared-clip",
    videoPublic: "/video", // PUT {key}/public -- admin toggles the public flag
    publicVideo: "/public-video",
  },
  timeout: 10000,
} as const;

export const AUTH_CONFIG = {
  authority: import.meta.env.VITE_COGNITO_AUTHORITY,
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  postLogoutRedirectUri: import.meta.env.VITE_COGNITO_POST_LOGOUT_REDIRECT_URI,
  responseType: "code",
  scope: "email openid",
} as const;

export const CACHE_CONFIG = {
  thumbnailTtl: 3600000, // 1 hour in milliseconds
  videoTtl: 300000, // 5 minutes in milliseconds
  videoUrlTtl: 1800000, // 30 minutes in milliseconds
} as const;

// A shared clip renders async after creation; the page polls the resolve
// endpoint until it's ready, then gives up so a stuck render shows an error
// instead of spinning forever.
export const SHARE_CONFIG = {
  pollIntervalMs: 2000,
  pollTimeoutMs: 90000,
} as const;
